import BoxWrapper from "../BoxWrapper";
import Pagination from "../Pagination";
import RenderTable from "../RenderTable";
import BookingReviewTable from "./tables/BookingReviewsTable";

interface Props {
  userBookingReviewsData: any;
  BookingReviewsFilters: any;
  isLoading: boolean;
  handleBookingReviewsPageChange: (page: number) => void;
  handleDeleteReview: (id: string) => void;
  isDeletingReview: boolean;
}

export const BookingReviewsTab: React.FC<Props> = ({
  userBookingReviewsData,
  isLoading,
  BookingReviewsFilters,
  handleBookingReviewsPageChange,
  handleDeleteReview,
  isDeletingReview,
}) => {
  return (
    <div className="p-4 border bg-white rounded-4">
      <h2 className="text-xl font-bold mb-4">Avis des Réservations </h2>

      <BoxWrapper>
        <div className="d-flex align-items-center justify-content-end gap-4 mt-5">
          {!isLoading && userBookingReviewsData?.meta.totalItems > 0 && (
            <div
              className="d-flex align-items-end bg-gradient-primary p-3 fs-5 fw-bold m-0  text-white mb-2"
              style={{ alignSelf: "flex-end", borderTopRightRadius: "8px" }}
            >
              <span className="me-2">Avis :</span>
              <strong>{userBookingReviewsData.meta.totalItems}</strong>
            </div>
          )}
        </div>

        {/* Reviews Table */}
        <RenderTable
          loading={isLoading && !userBookingReviewsData?.meta?.totalItems}
          render={() => {
            if (isLoading && !userBookingReviewsData?.meta?.totalItems) {
              return null;
            }

            return userBookingReviewsData?.meta?.totalItems > 0 ? (
              <BookingReviewTable
                reviews={userBookingReviewsData?.items}
                handleDeleteReview={handleDeleteReview}
                isDeletingReview={isDeletingReview}
              />
            ) : (
              <p className="text-center fs-5 my-2 p-4">Aucun avis trouvé.</p>
            );
          }}
        />
      </BoxWrapper>
      {userBookingReviewsData?.meta?.totalPages > 1 && (
        <Pagination
          currentPage={BookingReviewsFilters.page}
          onPageChange={handleBookingReviewsPageChange}
          totalCount={userBookingReviewsData?.meta?.totalPages || 0}
          pageSize={BookingReviewsFilters.limit}
          siblingCount={1}
        />
      )}
    </div>
  );
};
